module.exports = "/img/_/_/_/assets/images/creeper/book/rare//13.jpg?6434185caaba2bf2a4ea7330fc0b82c4";